import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
// import { createUploadLink } from 'apollo-upload-client'

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token'
const REFRESH_TOKEN = 'sid'

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql'
// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'))

Vue.prototype.$filesRoot = filesRoot

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  // httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  wsEndpoint: null,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,
}

const defaultClientOptions = {
  httpEndpoint,
  // link: createUploadLink(),
}

const authClientOptions = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_AUTH_CLIENT || 'http://localhost:4000/graphql',
}

const publicClientOptions = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_PUBLIC_HTTP || 'http://localhost:4000/graphql',
}

// Call this in the Vue app file
export function createProvider(options = {}) {
  const defApolloClient = createApolloClient({
    ...defaultClientOptions,
    ...defaultOptions,
  })

  const authApolloClient = createApolloClient({
    ...authClientOptions,
    ...defaultOptions,
  })

  const publicApolloClient = createApolloClient({
    ...publicClientOptions,
    ...defaultOptions,
  })

  // Create vue apollo provider
  return new VueApollo({
    defaultClient: defApolloClient.apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'network-only',
      },
    },
    clients: {
      default: defApolloClient.apolloClient,
      auth: authApolloClient.apolloClient,
      public: publicApolloClient.apolloClient,
      private: defApolloClient.apolloClient,
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    },
  })
}

// Manually call this when user log in
export async function onLogin(apolloClient, token, refreshToken = null) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
    if (refreshToken !== null) {
      localStorage.setItem(REFRESH_TOKEN, refreshToken)
    }
  }
  if (apolloClient.wsClient) {
    restartWebsockets(apolloClient.wsClient)
  }
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

export function refreshToken(token, refreshToken = null) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
    if (refreshToken !== null) {
      localStorage.setItem(REFRESH_TOKEN, refreshToken)
    }
  }
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN)
}

export function isSetToken() {
  return !!(typeof localStorage !== 'undefined' && localStorage.getItem(AUTH_TOKEN))
}

export function getToken() {
  return localStorage.getItem(AUTH_TOKEN)
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN)
    localStorage.removeItem(REFRESH_TOKEN)
  }
  if (apolloClient) {
    if (apolloClient.wsClient) {
      restartWebsockets(apolloClient.wsClient)
    }
    try {
      await apolloClient.resetStore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
    }
  }
}
